import React from "react";

const OlaplexWhy = () => {
  return (
    <div className="botoxHeadContainer">
      <h2>What is Keratin Hair Treatment?</h2>
      <p>
        At SCENT, we pride ourselves on offering the best{" "}
        <a href="https://scentlifestyle.com/olaplex-hair-treatments-in-bangalore">
          {" "}
          Olaplex hair treatments in Bangalore
        </a>
        . Our team of experienced stylists is trained in the latest techniques
        and uses only high-quality products to ensure you get the best results.
        We understand that every client’s hair is unique, which is why we tailor
        our{" "}
        <a href="https://scentlifestyle.com/olaplex-hair-treatments-in-bangalore">
          {" "}
          Olaplex treatments
        </a>{" "}
        to meet your specific needs.
      </p>
      <p>
        When you choose SCENT for{" "}
        <a href="https://scentlifestyle.com/">Olaplex hair treatments in Bangalore</a>, you’re choosing a
        salon that prioritizes your hair’s health and beauty. We take the time
        to assess your hair and recommend the best course of treatment to ensure
        you leave our salon with hair that feels as good as it looks.
      </p>
    </div>
  );
};

export default OlaplexWhy;
